import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import './index.css';
import 'react-tooltip/dist/react-tooltip.css';
import '@patternfly/react-core/dist/styles/base.css';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { isClientError } from './api';
import { LogVisualizer } from './log_visualizer/LogVisualizer';
import { LandingPage } from './LandingPage';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: (failureCount, error) => !isClientError(error) && failureCount < 3,
        },
    },
});

const router = createBrowserRouter([
    {
        index: true,
        element: <LandingPage />,
    },
    {
        path: 'logviz',
        element: <LogVisualizer />,
    },
    {
        path: ':addr',
        children: [
            {
                index: true,
                element: <Navigate to="epoch_info" />,
            },
            {
                path: '*',
                element: <App />,
            },
        ],
    },
]);

root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <RouterProvider router={router} />
        </QueryClientProvider>
    </React.StrictMode>
);
